import {
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarExport,
} from '@mui/x-data-grid';
const CustomToolbar = ({ setFilterButtonEl }) => (
  <GridToolbarContainer>
    {/*<GridToolbarFilterButton ref={setFilterButtonEl} />*/}
    <GridToolbarExport />
  </GridToolbarContainer>
);

export default CustomToolbar;
